import {
  BrandFilter,
  BrandFilterProduct,
  UpdateBrandFilterRequest,
  UserBrandFilters,
} from 'src/services/apiInterfaces';

export const ALL_BRANDS_VALUE = '__all_brands__';

export interface BrandFilterOption {
  label: string;
  value: string;
}

interface BrandOptionSource {
  brand_id: string;
  brand_name: string;
}

export const toBrandIds = (
  brandId?: string,
): UpdateBrandFilterRequest['brand_ids'] =>
  !brandId || brandId === ALL_BRANDS_VALUE ? [] : [brandId];

export const brandIdsToSelectValue = (brandIds: string[]): string =>
  brandIds[0] ?? ALL_BRANDS_VALUE;

export const areBrandIdsEqual = (a: string[], b: string[]): boolean =>
  a.length === b.length && a.every((id, index) => id === b[index]);

export const buildBrandFilterOptions = (
  brands: BrandOptionSource[],
  allBrandsLabel: string,
): BrandFilterOption[] => [
  { label: allBrandsLabel, value: ALL_BRANDS_VALUE },
  ...brands.map(brand => ({
    label: brand.brand_name,
    value: brand.brand_id,
  })),
];

export const mergeBrandFilterResponse = (
  existingBrandFilters: UserBrandFilters | undefined,
  product: BrandFilterProduct,
  updatedBrands: BrandFilter[],
): UserBrandFilters => ({
  ...existingBrandFilters,
  [product]: updatedBrands.map(brand => brand.brand_id),
});
